/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';

export default class IndexController extends Controller {
  // Services
  @service
  paperToaster;

  @service
  router;

  @service
  session;

  @service
  store;

  @tracked
  categoryId = '';

  @tracked
  label = '';

  @action
  setLabel(value) {
    this.label = value;
  }

  @tracked
  errorMessage = '';

  @tracked
  categoryDialogOpen = false;

  @tracked
  deleteCategoryDialogOpen;

  @tracked
  deleteInProgress;

  @tracked
  saveInProgress;

  // toggleDialog opens/closes the category dialog.
  toggleDialog() {
    this.errorMessage = '';
    this.toggleProperty('categoryDialogOpen');
    if (!this.categoryDialogOpen) {
      this.resetForm();
    }
  }

  @action
  toggleCategoryDialog() {
    this.toggleDialog();
  }

  @action
  editCategory(id) {
    this.store.findRecord('posts/tag-category', id).then((category) => {
      this.label = category.get('label');
    });
    this.categoryId = id;
    this.toggleDialog();
  }

  @action
  saveCategory() {
    this.saveInProgress = true;
    this.errorMessage = '';
    let promise;
    let action = 'create';

    if (isEmpty(this.categoryId)) {
      promise = new Promise((resolve) => {
        let record = this.store.createRecord('posts/tag-category', {
          label: this.label,
          schoolId: this.get('session.school'),
        });
        resolve(record);
      });
    } else {
      action = 'update';
      promise = new Promise((resolve) => {
        const id = this.categoryId;
        this.store.findRecord('posts/tag-category', id).then((category) => {
          category.set('label', this.label);

          resolve(category);
        });
      });
    }

    promise.then((record) => {
      return record
        .save()
        .then(() => {
          if (action === 'create') {
            // Send an event to trigger the route to refresh the model
            this.router.refresh('admin.tags.index');
          }

          this.categoryDialogOpen = false;
          this.resetForm();
        })
        .catch((err) => {
          this.handleError(err, action);
          record.rollbackAttributes();
        })
        .then(() => {
          this.saveInProgress = false;
        });
    });
  }

  @action
  deleteCategory(id) {
    this.errorMessage = '';
    this.store.findRecord('posts/tag-category', id).then((category) => {
      this.label = category.get('label');
    });
    this.categoryId = id;
    this.deleteCategoryDialogOpen = true;
  }

  @action
  confirmDelete(confirmed) {
    return new Promise((resolve, reject) => {
      if (confirmed) {
        // Deletion confirmed; actually delete the record.
        this.deleteInProgress = true;

        // Grab record from local store - no GET request, as that causes weirdness.
        // We only need the ID to issue the DELETE anyway, which can't change, so no need to use findRecord.
        let field = this.store.peekRecord(
          'posts/tag-category',
          this.categoryId,
        );

        // Delete record (locally + pushed to server).
        return field
          .destroyRecord()
          .then(resolve)
          .catch((err) => {
            // Remove 'deleted' flag so that entity can be interacted with again.
            field.rollbackAttributes();
            reject(err);
          });
      } else {
        resolve();
      }
    })
      .then(() => {
        // Tidy up / close dialog.
        this.deleteCategoryDialogOpen = false;
        this.resetForm();
      })
      .catch((err) => {
        this.handleError(err, 'delete');
      })
      .then(() => {
        this.deleteInProgress = false;
      });
  }

  handleError(err) {
    if (!isEmpty(err.errors.msg)) {
      this.errorMessage = err.errors.msg;
    } else if (!isEmpty(err.errors[0])) {
      let error = err.errors[0];
      if (!isEmpty(error.detail)) {
        this.errorMessage = error.detail;
      }
    } else {
      this.errorMessage = err.message;
    }
  }

  resetForm() {
    this.categoryId = '';
    this.label = '';
  }
}
